import { FC } from "react";
import styled from "styled-components";
import Paragraph from "../typography/Paragraph";
import { SERVICE_UNAVAILABLE_MESSAGE } from "../../helpers/serviceUnavailable";

const StyledServiceUnavailable = styled.div`
  padding: 20px 15px;
  text-align: center;
`;

const StyledTitle = styled(Paragraph)`
  margin-bottom: 8px;
`;

const StyledMessage = styled(Paragraph)`
  margin-bottom: 0;
`;

interface IServiceUnavailable {
  isMobile?: boolean;
}

export const ServiceUnavailable: FC<IServiceUnavailable> = ({
  isMobile,
}): JSX.Element => {
  return (
    <StyledServiceUnavailable>
      <StyledTitle size={18} lineHeight="1.16" weight={600}>
        We'll be right back
      </StyledTitle>
      <StyledMessage size={isMobile ? 14 : 16} lineHeight="1.5em" weight={400}>
        {SERVICE_UNAVAILABLE_MESSAGE}
      </StyledMessage>
    </StyledServiceUnavailable>
  );
};

export default ServiceUnavailable;
